
import { ButtonGhostV2, colors, colors2, transition } from "oolib";
import { globalScrollbarStyling } from "oolib/dist/v2/themes/globalStyles";
import styled from "styled-components";


export const StyledGridContainer = styled.div`
  grid-template-columns: ${({toggleState, lsbWidth, lsbClosedWidth, rsbWidth, rsbClosedWidth, lsbComp, rsbComp}) => {
    const currLsbWidth = toggleState.lsb ? lsbWidth : lsbClosedWidth;
    const currRsbWidth = toggleState.rsb ? rsbWidth : rsbClosedWidth
    switch(true){
      case !!lsbComp && !!rsbComp:
        return `${currLsbWidth}px 1fr ${currRsbWidth}px`
      case !!rsbComp:
        return `1fr ${currRsbWidth}px`
      case !!lsbComp:
        return `${currLsbWidth}px 1fr`  
    }
  }};
  height: ${({gridHeightCSS}) => gridHeightCSS};
  display: grid; 
  //disable transition during resizing, else it breaks the smoothness of the interaction.
  ${({resizeSidebarIsActive}) => !resizeSidebarIsActive.isActive && `transition: grid-template-columns 0.3s cubic-bezier(0.25, 1, 0.4, 1);`}

  //temp
  /* background: aqua; */
  position: relative;
  overflow: hidden; //so that when the sidebars are collapsed, its content actually gets hidden
`

export const StyledLSBSection = styled.section`
  /* background: lightgreen; */
  max-height: 100%; 
  overflow: auto; 
  overflow-x: hidden;
  justify-self: ${({toggleAnimationStyle}) => toggleAnimationStyle === 'slide' ? 'right' : 'left'}; 
  width: ${({lsbWidth, toggleAnimationStyle}) => toggleAnimationStyle === 'slide' ? lsbWidth+'px' : '100%'};
  border-right: 1px solid ${colors.greyColor10};
  background-color: ${colors.white};
  user-select: none;
  ${globalScrollbarStyling}
  /* position: relative; */ // this causes issues in seeing the lsb toggle button. has been commented out intentionally
`

export const StyledLSBToggleButton = styled(ButtonGhostV2)`
  position: absolute;
  top: 0;
  left: ${({lsbWidth, toggleState, lsbClosedWidth }) => {
    return toggleState.lsb ? lsbWidth+'px' : lsbClosedWidth + 'px'
    }};
  ${({resizeSidebarIsActive}) => !resizeSidebarIsActive.isActive && `transition: left 0.3s cubic-bezier(0.25, 1, 0.4, 1);`}
  background-color: ${colors.white};
  border: 1px solid ${colors2.grey10};
  // sticky headers inside sidebars commonly run at z-index 1000+; keep the
  // edge toggle button above them so it's never obscured.
  z-index: 1100;
`


export const StyledRSBSection = styled.section`
  /* background: lightgreen; */
  max-height: 100%; 
  overflow: auto; 
  overflow-x: hidden;
  justify-self: ${({toggleAnimationStyle}) => toggleAnimationStyle === 'slide' ? 'left' : 'right'}; 
  width: ${({rsbWidth, toggleAnimationStyle}) => toggleAnimationStyle === 'slide' ? rsbWidth+'px' : '100%'};
  border-left: 1px solid ${colors.greyColor10};
  background-color: ${colors.white};
  user-select: none;
  ${globalScrollbarStyling}
  /* position: relative; */
`

export const StyledRSBToggleButton = styled(ButtonGhostV2)`
  position: absolute;
  top: 0;
  right: ${({rsbWidth, toggleState, rsbClosedWidth }) => {
    return toggleState.rsb ? rsbWidth+'px' : rsbClosedWidth + 'px'
    }};
  ${({resizeSidebarIsActive}) => !resizeSidebarIsActive.isActive && `transition: right 0.3s cubic-bezier(0.25, 1, 0.4, 1);`}
  background-color: ${colors.white};
  border: 1px solid ${colors2.grey10};
  z-index: 1100;
`

export const StyledContentSection = styled.section`
  background: ${colors.white};
  overflow: auto;
  /* Opt-in per page ($scrollbar) so pages that style their own scroll
     containers are unchanged; the AI chat turns it on for its centre column. */
  ${({ $scrollbar }) => $scrollbar && globalScrollbarStyling}
`